import { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PrivateFoundationDetail } from '../../../../../../components/PrivateFoundationDetail'
import { PrivateFoundationSelectors } from '../../../../../../store/privateFoundation'
import { AddToProjectButton } from '../../../AddToProjectForm'
import { AddToProjectModal } from './AddToProjectModal'

export const PrivateFoundation: FC = () => {

  const [openProjectModal, setOpenProjectModal] = useState<boolean>(false)

  const pf = useSelector(PrivateFoundationSelectors.makeFoundation)

  const {einNumber = ''} = pf

  return (
    <>
      <AddToProjectModal itemToAdd={einNumber} open={openProjectModal} setOpen={setOpenProjectModal} />

      <PrivateFoundationDetail
        privateFoundation={pf}
        AddToProjectButton={<AddToProjectButton onClick={() => setOpenProjectModal(true)} />}
      />
    </>
  )
}
